import { useOutletContext } from "react-router-dom";

import Unauthorized from "../../ui/components/Unauthorized/Unauthorized";

import useHasRight from "../../authorization/hooks/useHasRight";

import AgreementsPendingView from "../views/AgreementsPendingView/AgreementsPendingView";

export default function AgreementsPending() {
	const { organization } = useOutletContext();

	const hasRight = useHasRight();

	if (!hasRight("agreements.view")) {
		return <Unauthorized />;
	}

	return <AgreementsPendingView firstPartyId={organization.id} />;
}
